import { render } from "./CategoryTree2IconSetting.vue?vue&type=template&id=00632f1c&scoped=true"
import script from "./CategoryTree2IconSetting.vue?vue&type=script&lang=js"
export * from "./CategoryTree2IconSetting.vue?vue&type=script&lang=js"

import "./CategoryTree2IconSetting.vue?vue&type=style&index=0&id=00632f1c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00632f1c"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/CategoryTree2IconSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00632f1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00632f1c', __exports__)) {
    api.reload('00632f1c', __exports__)
  }
  
  module.hot.accept("./CategoryTree2IconSetting.vue?vue&type=template&id=00632f1c&scoped=true", () => {
    api.rerender('00632f1c', render)
  })

}


export default __exports__